/**
 *
 * @return {Element}
 */
function layoutElement() {
    return document.querySelector('.layout-element');
}

/**
 *
 * @return {Element}
 */
function layoutPortalElement() {
    return document.querySelector('.layout-portal');
}

/**
 *
 * @return {Element|null}
 */
function layoutHeader() {
    return document.querySelector('.top-nav');
}

/**
 *
 * @return {Element|null}
 */
function layoutScrollElement() {
    return document.querySelector('.page-content');
}

const domQueries = {
    layoutElement,
    layoutPortalElement,
    layoutHeader,
    layoutScrollElement,
};

export default domQueries;
